import React from "react";

const FooterFacebookIcon = (): JSX.Element => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 319.81 319.81"
  >
    <defs>
      <clipPath id="clip-path" transform="translate(-146.1 -138.84)">
        <path
          className="cls-1"
          fill="none" clipRule="evenodd" d="M451.37,299.64c0,73-53.16,133.5-122.66,144.47V341.91h33.88L369,299.64H328.71V272.2c0-11.57,5.64-22.85,23.69-22.85h18.33v-36a222.58,222.58,0,0,0-32.53-2.85c-33.22,0-54.91,20.24-54.91,56.91v32.22H246.37v42.27h36.92v102.2c-69.5-11-122.66-71.47-122.66-144.47,0-80.78,65.08-146.26,145.37-146.26S451.37,218.86,451.37,299.64Z"
        />
      </clipPath>
      <clipPath id="clip-path-2" transform="translate(-146.1 -138.84)">
        <rect className="cls-2" fill="none" x="160.63" y="153.38" width="290.74" height="290.74" />
      </clipPath>
    </defs>
    <g className="cls-3" clip-path="url(#clip-path)">
      <g className="cls-4">
        <g className="cls-5" clip-path="url(#clip-path-2)">
          <g className="cls-5" clip-path="url(#clip-path-2)">
            <rect width="319.81" height="319.81" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FooterFacebookIcon;
